import { useOutletContext } from "react-router-dom";
import TINNRLayout from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import { useEffect } from "react";
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import PageBanner from "@/components/PageBanner";
import { isEmpty } from "lodash";
import EResourceType from "@/cms/enums/EResourceType";
import ContentRenderer from "@/components/ContentRenderer";
import ContentInnerHeader from "@/components/ContentInnerHeader";


const INNR_004 = ( props:TINNRLayout ) => {
    console.log("INNR_004.rendered: ", props);

    const { contentId, _showLoader, _hideLoader } = useOutletContext<TOutletContext>();

    useEffect(() => { return () => { _showLoader() }},[])
    useEffect(() => { setTimeout(() => { _hideLoader(); }, 100) },[contentId])
    
    if ( !props.contentDetailPayload?.languageVersions || isEmpty(props.contentDetailPayload?.languageVersions) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.contentDetailPayload.languageVersions);

    return (
        <>
            <PageBanner title={languageVersion?.name} resources={props.contentDetailPayload.resources} resourceType={EResourceType.PARALLAX} />
            <div className="services-details-area ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <ContentInnerHeader payload={props.contentDetailPayload} metaInformationEnabled />
                        </div>

                        <div className="col-12">
                            <ContentRenderer
                                languageVersions={props.contentDetailPayload.languageVersions}
                            />
                        </div>
                    </div>
                </div>
            </div>
      </>
    );
}

export default INNR_004;
